import React, { useContext } from "react";
import { PopupContext } from "../../index";
import { saveDeviceTypeFetchConfigCommand } from "./systemSettingsService";
import { getConfirmPopup } from "../../view/popup/PopupContainer";
import { showSuccessToast, showDangerToast } from "../../validation/ToastContainer";

function FetchCommandField({ value, deviceType, onChange }) {

    // const history = useHistory();
    const { setPopup } = useContext(PopupContext);

    const handleChange = (value) => {
        onChange(value);
    }

    const onSaveClick = async () => {
        if (deviceType) {
            const newFetchCommand = {
                fetchCommand: value,
                deviceTypeId: deviceType.id
            }

            setPopup(
                getConfirmPopup('Are you sure?',
                    'Update DeviceType Fetch Command',
                    () => saveDeviceTypeFetchConfigCommand(newFetchCommand)
                        .then(success => {
                            if (success) {
                                showSuccessToast('Fetch Command for the Selected DeviceType is updated successfully', 'DeviceType Fetch Command');
                            } else {
                                showDangerToast('There was an error updating the Fetch Command for the Selected DeviceType, please review with support', 'DeviceType Fetch Command');
                            }
                        }
                        )
                )
            )
        }
    }

    return (
        <div className="oct_settings-field mt-3">
            <label className="oct_settings-label">Fetch Command</label>
            <textarea
                className="oct_settings-textarea"
                rows={3}
                value={value}
                onChange={(e) => handleChange(e.target.value)}
            />
            <button
                type="button"
                className="oct_settings-btn-v2 mt-3"
                onClick={() => onSaveClick()}
            >
                Save
            </button>
        </div>
    )
}

export default FetchCommandField;
